import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { ClienteLogin, ClienteXCiudad } from "../../../login/cliente_login";
import { correctHeight, detectBody } from "../../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../../components/common/utils/sessionToken.service";
import { ContragarantiasService } from "./contragarantias.service";
import { ContragarantiasEntity } from ".././entities/contragarantias_entity";
import { UsuarioLoginEntity } from "../../../login/usuario_login_entity";


const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'contragarantias',
    providers: [ContragarantiasService],
    templateUrl: 'contragarantias.template.html',
    // styleUrls: ["datos-generales-empresa.style.css"]

})

export class Contragarantias implements OnInit {
    showLoader: string;
    usuario: ClienteLogin;
    userEmpresa: ClienteXCiudad;
    usuarioLogin: UsuarioLoginEntity;
    listaContragarantias: ContragarantiasEntity[];
    constructor(private contragarantiasService: ContragarantiasService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService
    ) {
    }
    ngOnInit(): void {

        /*correctHeight();
        detectBody();*/
        this.showLoader = "sk-loading";        
        try {
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        } catch (e) {
            this.usuario = this.sesionStorageService.retrieve("usuario");
        }
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.listaContragarantias = new Array<ContragarantiasEntity>();
                try {
                    this.userEmpresa = jQuery.parseJSON(this.sesionStorageService.retrieve("usuarioEmpresa"));
                } catch (e) {
                    this.userEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                }
                this.CargarTodo();
                this.sesionStorageService.observe("usuarioEmpresa").subscribe(a => {
                    try {
                        this.userEmpresa = jQuery.parseJSON(a);
                    } catch (e) {
                        this.userEmpresa = a;
                    }
                    this.CargarTodo();
                })


            }
        }

    }

    CargarTodo() {
        this.contragarantiasService.consultarListaContragarantias(this.userEmpresa).subscribe(contragarantiasData => {
            this.listaContragarantias = contragarantiasData;
            this.showLoader = "";
        }, error => this.handleError.redirectUrl(error));

    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/fianzas/contragarantias/contragarantias.component.ts